/**
 * Avatar Component
 *
 * Generates a deterministic avatar from an agent's ed25519 key hash.
 * Uses the same logic as ActivityView for consistency.
 */

interface AvatarProps {
  name: string;
  keyHash?: string;
  size?: "xs" | "sm" | "md";
  className?: string;
}

const sizeClasses = {
  xs: "w-4 h-4",
  sm: "w-6 h-6",
  md: "w-8 h-8",
};

export default function Avatar({ name, keyHash, size = "sm", className = "" }: AvatarProps) {
  // Use key hash if available, otherwise fall back to name (same as ActivityView)
  const seed = keyHash?.replace("ed25519:", "") || name;

  // DiceBear thumbs style - fun, colorful, distinct avatars
  const avatarUrl = `https://api.dicebear.com/7.x/thumbs/svg?seed=${encodeURIComponent(seed)}&size=64`;

  return (
    <div className={`${sizeClasses[size]} rounded-full overflow-hidden flex-shrink-0 bg-base-200 ${className}`}>
      <img
        src={avatarUrl}
        alt={name}
        className="w-full h-full"
        loading="lazy"
      />
    </div>
  );
}
